import { ServiciosAdicionalesGuia, TipoAcuse } from "./guia";

/**
   * Una tarifa de guia prepagada aplica ya sea para un paquete o un sobre.
   * La logica es la siguiente:
   * Al definir una tarifa de PP se define la tarifa de referencia y los datos del envio de referecia (suc orig, destino, peso, vol, serv. adic)
   * /// El precio de una de estas guías será igual al de aplicar la tarifa de referencia a los datos del envio de referencia. 
   * Ej. si la tarifa de referencia es "Convenio general" y los datos del envio de referencia son (orig. CEN, dest HMO, peso 3 kg, vol. 1000cm3, con EAD sin RAD)
   * El "precio de referencia" de una guía de esta tarifa PP será el de aplica esos datos de referencia a esta tarifa.
   * /// El precio de referencia será lo que cueste comprar una de estas guías de prepago, además de que servirá de base para obtener el costo extra de una guia
   * en caso de que el cliente quiera mandar una guía con parámetros diferentes a los de referencia.
   * /// Ej. Si el usuario compro una guia prepago con EAD pero sin RAD, pero quiere incluir RAD, tendrá que pagar la diferencia entre el precio de referencia y el precio pero con RAD,
   * efectivamente cobrandole al usuario el extra deseado, esto aplica igual si quiere mandar guias con pesos o volumenes mayores, o entre sucursales más lejanas
   */
export interface TarifaPP {
    IdRegistro: number;

    /**Nombre de la tarifa */
    Nombre: string;

    /**Si aplica para un paquete */
    Paquete: boolean;

    /**Si aplica para un sobre */
    Sobre: boolean;

    /**Id de la tarifa que va a aplicar para estas guías de PP */
    IdTarifa: number;

    /**Id de la sucursal de origen de referencia para esta tarifa */
    IdSucursalOrigen: number;

    /**Id de la sucursal destino de referencia para esta tarifa */
    IdSucursalDestino: number;

    /**Id del contenido del paquete de referencia */
    IdContenidoPaquete: number;

    /**Id de la descripción del paquete de referencia */
    IdDescripcionPaquete: number;

    /**Peso de referencia en kg */
    Peso: number;

    /**Dimensión de referencia en cm */
    Largo: number;

    /**Dimensión de referencia en cm */
    Alto: number;

    /**Dimensión de referencia en cm */
    Ancho: number;

    /**Servicios adicionales de referencia para obtener el precio base de la tarifa */
    ServiciosAdicionales: ServiciosAdicionalesTarifaPP;

    /**Descuentos por cantidad de guías compradas */
    Descuentos: TarifaPPDescuento[];
}

export interface ServiciosAdicionalesTarifaPP {
    /**Si incluye entrega a domicilio */
    EntregaDomicilio: boolean;
    /**Si incluye recolección a domicilio */
    RecoleccionDomicilio: boolean;

    /**Tipo de acuse o null si no lleva acuse */
    Acuse: TipoAcuse | null;

    ValorDeclarado: number;

    ValorFactura: number;
    ServicioEspecial: number;

}

/**Indica un descuento para la compra de guias de prepago después de cierta cantidad */
export interface TarifaPPDescuento {
    IdRegistro: number;

    /**Id de la tarifa a la que aplican estos descuentos */
    IdTarifaPP: number;
    TarifaPP: TarifaPP;

    /**Si la cantidad comprada es mayor o igual a este valor y menor a la del siguiente rango aplica este descuento */
    Cantidad: number;

    /**Descuento aplicado en porcentaje */
    Descuento: number;
}

export interface TarifaPPDto extends TarifaPP {
    NombreTarifa: string;
    NombreContenidoPaquete: string;
    NombreDescripcionPaquete: string;
}

/**Si es paquete o sobre */
export enum TipoServicio {
    Paquete,
    Sobre
}

/**Los datos necesarios para obtener el precio y el costo extra de una guía de prepago */
export interface DatosReferenciaTarifaPP {
    /**Id de la sucursal de origen de referencia para esta tarifa */
    IdSucursalOrigen: number;

    /**Id de la sucursal destino de referencia para esta tarifa */
    IdSucursalDestino: number;

    /**Id del contenido del paquete de referencia */
    IdContenidoPaquete: number;

    /**Id de la descripción del paquete de referencia */
    IdDescripcionPaquete: number;

    /**Peso de referencia en kg */
    Peso: number;

    /**Dimensión de referencia en cm */
    Largo: number;

    /**Dimensión de referencia en cm */
    Alto: number;

    /**Dimensión de referencia en cm */
    Ancho: number;

    /**Servicios adicionales de referencia para obtener el precio base de la tarifa */
    ServiciosAdicionales: CalculoTarifaServiciosAdicionales;
}

/**Servicios adicionales que afectan para el cálculo de la tarifa */
export interface CalculoTarifaServiciosAdicionales {
    EntregaDomicilio: boolean;
    RecoleccionDomicilio: boolean;
    ValorDeclarado: number | null;
    Acuse: TipoAcuse | null;
}

/**Importes resultado de aplicar cierta tarifa a un modelo */
export interface ImportesTarifa {
    /**Flete antes del descuento */
    FleteSinDescuento: number;

    /**Flete con descuento */
    Flete: number;

    Seguro: number;
    ValorFactura: number;
    EntregaDomicilio: number;
    RecoleccionDomicilio: number;
    Acuse: number;
}

/**Totales e impuestos calculados de los importes obtenidos de una guía y tarifa */
export interface TotalesImportesTarifa {
    Subtotal: number;
    Iva: number;
    RetencionIva: number;
    Total: number;
}

/**Importes y totales en el mismo objeto */
export interface ImportesTotalesTarifa {
    Importes: ImportesTarifa;
    Totales: TotalesImportesTarifa;
}


// WEBPACK FOOTER //
// ./app/models/tarifapp.ts